module.exports = __webpack_public_path__ + "img/back_Y.f437166b.png";